import React from 'react';
import PropTypes from 'prop-types';
import Container from '../PageBuilder/lib/Container';
import Img from '../PageBuilder/lib/Image';
import List from '../PageBuilder/List';
import ImagePicker from '../PageBuilder/pickers/ImagePicker/ImagePicker';
import TextInput from '../PageBuilder/forms/TextInput';
import TextArea from '../PageBuilder/forms/TextArea';

const HorizontalFeedWidget = ({ list, containerSettings }) => (
  <div className="horizontal-feed">
    <Container settings={containerSettings}>
      <div>
        {list.map((item, idx) =>
          <article key={idx} className="flex-grid-four-and-eight">
            <div className="col">
              <a href={item.link}>
                <Img src={item.image} variant="article_feed_2" />
              </a>
            </div>

            <div className="col">
              <h6 className="sup-title">{item.meta}</h6>
              <h4 className="title"><a href={item.link}>{item.title}</a></h4>

              <div className="desc">
                <p>{item.description}</p>
              </div>
            </div>
          </article>)}
      </div>
    </Container>
  </div>
);

HorizontalFeedWidget.title = 'Horizontal Feed';
HorizontalFeedWidget.preview = 'horizontal-feed.png';
HorizontalFeedWidget.category = 'Lists';

HorizontalFeedWidget.propTypes = {
  list: PropTypes.array.isRequired,
  containerSettings: PropTypes.object.isRequired,
};

HorizontalFeedWidget.defaults = {
  list: [
    { id: 1, link: '#', image: 'http://placehold.it/370x248', title: 'Article Title', meta: 'Summary, or meta info', description: 'Трябва да разбереш, нашето общество е толкова огромно, че не можем да позволим на когото и да било да дразни и вълнува отделните групи, които го съставляват. Запитай се сам какво преди всичко желаем ние в нашата страна.' },
  ],
  containerSettings: {},
};

const HorizontalFeedField = ({ settings, onChangeItem }) => (
  <div>
    <ImagePicker
      onChange={value => onChangeItem('image', value)}
      value={settings.image}
    />

    <TextInput
      label="Title"
      onChange={value => onChangeItem('title', value)}
      value={settings.title}
    />

    <TextInput
      label="Link"
      onChange={value => onChangeItem('link', value)}
      value={settings.link}
    />

    <TextInput
      label="Meta"
      onChange={value => onChangeItem('meta', value)}
      value={settings.meta}
    />

    <TextArea
      label="Short Description"
      onChange={value => onChangeItem('description', value)}
      value={settings.description}
    />
  </div>
);

HorizontalFeedField.propTypes = {
  settings: PropTypes.object.isRequired,
  onChangeItem: PropTypes.func.isRequired,
};

HorizontalFeedWidget.adminFields = (items, onChange, settings) => (
  <List
    listItem={(settings, onChangeItem) =>
      <HorizontalFeedField settings={settings} onChangeItem={onChangeItem} />}
    onChangeList={onChange}
    items={items}
  />
);

export default HorizontalFeedWidget;

